import { useLocation } from 'react-router';

export const useLocationParams = () => {
  const location = useLocation<{ categoryId?: number; idCharts?: number[] }>();
  const { state } = location;

  const categoryId = state?.categoryId;
  const idCharts = state?.idCharts;

  return { idCharts, categoryId };
};
